import React, { FC } from 'react'
import { Flex, Link, Text } from '@moonpig/launchpad-components'
import {
  IconSystemLocation,
  IconSystemReminder,
  IconSystemReplace,
} from '@moonpig/launchpad-assets'
import { spacingPx, theme, colorValue } from '@moonpig/launchpad-theme'
import { styled } from '@moonpig/launchpad-utils'
import { ProductModule } from '../types'
import { useProductContext } from '../../../contexts/product'
import { useFindLocaleText } from '../../../text-localisation'

const ICON_SPACING = spacingPx(3)({ theme })

const LocationsIcon = styled(IconSystemLocation)`
  color: ${colorValue('colorTextHeadline')({ theme })};
`

export const ProductSellingPointsModule: FC<ProductModule> = ({ ...props }) => {
  const [
    {
      product: {
        variants: [{ locations }],
      },
    },
  ] = useProductContext()

  const localiseText = useFindLocaleText()

  return (
    <Flex
      bgcolor={'colorBackground05'}
      width={1}
      justifyContent="space-evenly"
      flexWrap="wrap"
      py={5}
      {...props}
    >
      {locations?.length ? (
        <Link href="#locations">
          <Flex gap={ICON_SPACING} alignItems="center">
            <LocationsIcon height={'1.4rem'} />
            <Text typography={'typeButtonTextLink'} color="colorTextHeadline">
              {locations?.length}{' '}
              {localiseText('find.locations_title', locations.length)}
            </Text>
          </Flex>
        </Link>
      ) : null}
      <Flex gap={ICON_SPACING} alignItems="center">
        <IconSystemReminder height={'1.4rem'} />
        <Text>{localiseText('find.immediate_delivery')}</Text>
      </Flex>
      <Flex gap={ICON_SPACING} alignItems="center">
        <IconSystemReplace height={'1.4rem'} />
        <Text>{localiseText('find.exchangeable')}</Text>
      </Flex>
    </Flex>
  )
}
